<template>
    <div class="team-members my-5 p-4">
        <h2>Our team members</h2>
        <p>Our dedicated tax advisor <br> financial consulting will help you!</p>
        <carousel :per-page="1" :breakpoints="breakpoints" :navigate-to="someLocalProperty" autoplay="true" loop="true"
            class="d-block d-md-none">
            <slide v-for="(user, ur) in people" :key="ur">
                <div class="d-flex user-card mx-2">
                    <img :src="getImage(user.image)" alt="user image" height="90" class="user-image">
                    <div class="ml-2">
                        <h4 class="font-weight-bold">{{ user.name }}</h4>
                        <p class="font-weight-bold text-info mb-0">{{ user.role }}</p>
                        <p>{{ user.description }}</p>
                    </div>
                </div>
            </slide>
        </carousel>
        <carousel :per-page="3" :breakpoints="breakpoints" :navigate-to="someLocalProperty" autoplay="true" loop="true"
            class="d-none d-md-block">
            <slide v-for="(user, ur) in people" :key="ur">
                <div class="d-flex user-card mx-2">
                    <img :src="getImage(user.image)" alt="user image" height="90" class="user-image">
                    <div class="ml-2">
                        <h4 class="font-weight-bold">{{ user.name }}</h4>
                        <p class="font-weight-bold text-info mb-0">{{ user.role }}</p>
                        <p>{{ user.description }}</p>
                    </div>
                </div>
            </slide>
        </carousel>
    </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: "TeamMembers",
    data() {
        return {
            people: [
                {
                    name: "Abhijith K C",
                    image: "abhijith",
                    role: "Founder, Financial planning & Tax advisor",
                    description: "Worked at big4, expert in tax services",
                    socialMedia: [
                        { name: "Facebook", link: "" },
                        { name: "instagram", link: "" },
                    ]
                },
                {
                    name: "Kavya",
                    image: "kavya",
                    role: "GST, ITR",
                    description: "Specilist in filing GST, ITR",
                    socialMedia: [
                        { name: "Facebook", link: "" },
                        { name: "instagram", link: "" },
                    ]
                },
                {
                    name: "Deepashree",
                    image: "deepashree",
                    role: "Tax advisor",
                    description: "Specilist in filing GST, ITR",
                    socialMedia: [
                        { name: "Facebook", link: "" },
                        { name: "instagram", link: "" },
                    ]
                },

                {
                    name: "Harinakshi",
                    image: "harini",
                    role: "Tax audit",
                    description: "Internal and tax audit expert",
                    socialMedia: [
                        { name: "Facebook", link: "" },
                        { name: "instagram", link: "" },
                    ]
                },
                {
                    name: "Bharath raj",
                    image: "bharath",
                    role: "Banking",
                    description: "Specilist in Banking sector",
                    socialMedia: [
                        { name: "Facebook", link: "" },
                        { name: "instagram", link: "" },
                    ]
                },
                {
                    name: "Sudharshan",
                    image: "sudarshan",
                    role: "Legal consultant",
                    description: "Legal consultant",
                    socialMedia: [
                        { name: "Facebook", link: "" },
                        { name: "instagram", link: "" },
                    ]
                }
            ]
        };
    },
    components: {
        Carousel,
        Slide
    },
    methods: {
        getImage(img) {
            return require(`@/assets/team/${img}.png`);
        }
    }
};
</script>
<style>
.team-members {
    border: 1px solid #ddd;
    border-radius: 12px;
}

.user-image {
    border-radius: 50%;
}

.user-card {
    /* background-color: #ddd; */
}
</style>